/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactHTMLParser from 'react-html-parser';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import Button from '@material-ui/core/Button';

import EventDispatcher from '../../state/reducers/EventDispatcher';

class HTMLContent extends React.Component {
    pageReload = () => {
        console.log('Reload page');
    };

    render() {
        const { content, config, handleCloseModal } = this.props;

        return (
            <>
                <div className="split">
                    {config === 'ErrorOutline' ? (
                        <ErrorOutline className="modal-error-icon flex-none" />
                    ) : (
                        ''
                    )}
                    <div>{ReactHTMLParser(content)}</div>
                </div>
                {config === 'ReloadButton' ? (
                    <Button
                        variant="contained"
                        className="margin-top margin-bottom-half"
                        onClick={() => this.pageReload()}
                    >
                        Reload Page
                    </Button>
                ) : (
                    ''
                )}
                {config === 'ErrorOutline' ? (
                    <div className="align-center">
                        <Button
                            variant="contained"
                            className="margin-top margin-bottom-half"
                            onClick={() => handleCloseModal()}
                        >
                            Close
                        </Button>
                    </div>
                ) : (
                    ''
                )}
            </>
        );
    }
}

HTMLContent.defaultProps = {
    content: '',
    config: '',
};

HTMLContent.propTypes = {
    content: PropTypes.string,
    config: PropTypes.string,
    handleCloseModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    handleCloseModal: () => dispatch(EventDispatcher.handleCloseModal()),
});

export default connect(
    null,
    mapDispatchToProps,
)(HTMLContent);
